export const gitCommit = '98ebcb2a'
